import axios from "axios";

const post = (userId) => {
  const body = {
    user_id: userId
  };

  return new Promise((resolve, reject) => {
    axios
      .post("/account/api/v1/users/resend-email", body)
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

const resendEmail = {
  post
};

export default resendEmail;
